<template >
    <div class="rightPanelContainer">
        <slot name="content">content</slot>
    </div>
</template>
<script>
export default {
    name: 'rightPanel'
}
</script>